<div class="container">
    <div class="content">
        <div class="title-container" data-cy="channels-insert-row-modal-header">
            {{ data.title | translate }}
        </div>
        <div class="message">
            {{ 'dlg.channel-sheet.insert-rows.max-rows-allowed' | translate }}
        </div>
        <div class="error-message" data-cy="channels-insert-row-modal-error-message" *ngIf="!this.data.coord">
            {{ 'input-text.errors.NOT_SELECTED_ROW' | translate }}
        </div>
        <div class="input-wrapper">
            <app-channel-text-input
                name="rows-number"
                label="dlg.channel-sheet.insert-rows.label"
                [value]="''"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputValueValidation]="numberValidation.bind(this)"
                maxLength="4"></app-channel-text-input>
        </div>
    </div>
    <div class="buttons-container">
        <button data-cy="channels-insert-row-modal-cancel-button" (click)="close(false)" class="primary">
            {{ 'dlg.cancel' | translate }}
        </button>
        <button
            data-cy="channels-insert-row-modal-add-button"
            (click)="close(rowNumber)"
            class="white"
            [class.disabled]="!rowNumber || !this.data.coord || this.hasError">
            {{ 'dlg.add' | translate }}
        </button>
    </div>
</div>
